import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';
import numeral from 'numeral';
import moment from 'moment';

import AsyncSelect from 'react-select/async';

import {
    Route,
    useHistory,
    useRouteMatch,
} from 'react-router-dom';

import { Formik } from 'formik';

import styled from 'styled-components';

import {
    Container, CenteredTD, Header, HeaderActions, PrimaryButton, Panel, Toolbar, ToolbarFilters, SearchBox, ClearButton,
    FilterSelect, GhostButton, TableScroll, ListTable, Chip, StatusDot, RowMenuToggle, Drawer, DrawerBackdrop, DrawerPanel,
    DrawerHeader, IconButton, DrawerBody, StatusActions, DrawerTabs, SectionHeader, FormActions, Footer, PageButton,
    StyledToast, StyledTR,
} from '../ManageLayout';

import { Button, Form, InputGroup, Row, Col, Modal, Toast, Tab, Dropdown } from 'react-bootstrap';

import { getRiscoEscala } from '../../utils';

import { faPencilAlt, faTrashAlt, faCheck, faTimes, faToggleOff, faToggleOn, faDownload, faSearch, faColumns, faArrowLeft, faArrowRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const colspan = 12;

const lastYear = moment()/* .subtract(1, 'y') */.year();

async function fetchEntities(page = 1, filters) {

    let url = `${process.env.REACT_APP_SERVER}geo-service/manage/producers?page=${page}`;

    // handle filters
    const urlFilters = buildFilterQuery(filters);

    return await axios.get(`${url}&${urlFilters.join('&')}`);

}

function buildFilterQuery(filters) {
    let urlFilters = [];
    for (let f of Object.keys(filters)) {
        if (!!filters[f]) urlFilters.push(`${f}=${encodeURIComponent(filters[f])}`);
    }

    return urlFilters;
}

function ManageProducers() {
    const [producers, setProducers] = useState([]);
    const [maxYear, setMaxYear] = useState(lastYear);
    const [paginatorData, setPaginatorData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [filters, _filters] = useState({
        name: false,
        assoc: false,
        cpf: false,
        status: false,
    });

    const history = useHistory();

    const [costPerKilo, setCostPerKilo] = useState(0);

    const [assocs, setAssocs] = useState([]);
    useEffect(() => {
        async function fetchAssocs() {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/assocs`);
            setAssocs(data);
        }

        fetchAssocs();
    }, []);

    useEffect(() => {
        async function fetchProducers(page = 1, filters) {

            const { data: { rows, pages, hasPrevious, hasNext, maxYear, cost } } = await fetchEntities(page, filters);

            setProducers(rows);
            setPaginatorData({ pages, hasPrevious, hasNext });
            setMaxYear(maxYear);
            setCostPerKilo(cost);
        }

        if (currentPage) fetchProducers(currentPage, filters);
    }, [currentPage, filters]);

    const handlePageChange = (page) => {
        // TODO: loading...

        setCurrentPage(page);
    }

    const handleEdit = (gid) => {
        history.push(`/produtores/gerenciar/${gid ? gid : ''}`);
    }

    const handleUpdate = async (newId) => {
        doToast('Os dados do produtor foram gravados!');

        const { data: { rows, pages, hasPrevious, hasNext, maxYear, cost } } = await fetchEntities(currentPage, filters);

        setProducers(rows);
        setPaginatorData({ pages, hasPrevious, hasNext });
        setMaxYear(maxYear);
        setCostPerKilo(cost);

        if (!newId) refresh();
        else history.replace(`/produtores/gerenciar/${newId}`);

    }

    const handleClose = () => {
        history.push('/produtores');
    }

    const handleDelete = () => {
        doToast('O produtor foi removido!');
        handleClose();
        refresh();
    }

    const handleStatus = () => {
        doToast('O status do produtor foi atualizado!');
        refresh();
    }

    const doToast = (message) => {
        setToastMessage(message);
        setShowToast(true);
    }

    const refresh = () => {
        // TODO: best practices
        const currentPageCopy = currentPage;
        setCurrentPage(null);
        setCurrentPage(currentPageCopy);
    }

    const handleFilter = (filterName, value) => {

        let newFilters = {
            ...filters,
            [filterName]: value,
        };

        // regras de incompatibilidade
        if (filterName === 'cpf' && !!value) {
            newFilters.name = false;
            newFilters.assoc = false;
        }
        if (['name', 'assoc'].includes(filterName) && !!value) newFilters.cpf = false;

        _filters(newFilters);
    }

    const handleExport = async () => {
        const urlFilters = buildFilterQuery(filters);
        const url = `${process.env.REACT_APP_SERVER}geo-service/manage/producers/export?${urlFilters.join('&')}`;
        const { data } = await axios.get(url, { responseType: 'blob' });
        const downloadUrl = window.URL.createObjectURL(data);
        const link = document.createElement('a');

        link.href = downloadUrl;
        link.setAttribute('download', 'produtores.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
    }

    return <>
        <List
            currentPage={currentPage}
            producers={producers}
            maxYear={maxYear}
            paginatorData={paginatorData}
            filters={filters}
            handlePageChange={handlePageChange}
            handleEdit={handleEdit}
            handleFilter={handleFilter}
            handleExport={handleExport}
            costPerKilo={costPerKilo}
            assocs={assocs}
        />

        <Route path="/produtores/gerenciar/:id?" render={({ match }) => (
            <Manage
                key={match.params.id || 'new'}
                gid={match.params.id}
                row={producers && producers.find((producer) => String(producer.gid) === match.params.id)}
                assocs={assocs}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
                onStatus={handleStatus}
                onClose={handleClose}
            />
        )} />

        <StyledToast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
            <Toast.Header>
                <FontAwesomeIcon icon={faCheck} />
                <strong className="mr-auto">Sucesso</strong>
            </Toast.Header>
            <Toast.Body>{toastMessage}</Toast.Body>
        </StyledToast>
    </>;
}

function Manage({ gid, row, assocs, onUpdate, onDelete, onStatus, onClose }) {
    const [key, setKey] = useState('main');

    const [status, setStatus] = useState(null);
    const [changingStatus, setChangingStatus] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const [data, setData] = useState({
        nome: '',
        colocacao: '',
        seringal: '',
        ai_type: 'radius',
        ai_radius: 1500,
        lat: '',
        long: '',
    });

    useEffect(() => {
        async function fetchProducer(gid) {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}`);
            setData(data);
        }

        if (gid) fetchProducer(gid);
    }, [gid]);

    const refresh = async () => {
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}`);
        setData(data);
    }

    const handleUpdate = () => {
        refresh();
        onUpdate();
    }

    const handleMainUpdate = (newId) => {
        if (!newId) refresh();
        onUpdate(newId);
    }

    // Fecha com ESC, exceto quando há um modal (confirmação, família, produção) aberto por cima
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && !document.body.classList.contains('modal-open')) onClose();
        }

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    const currentStatus = status || data.status || (row && row.status) || null;

    const toggleStatus = async () => {
        const next = currentStatus === 'ativo' ? 'inativo' : 'ativo';

        setChangingStatus(true);
        try {
            await axios.put(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}/${next}`);
            setStatus(next);
            onStatus();
        } catch (e) {
            console.log(e);
        }
        setChangingStatus(false);
    }

    const handleRemove = async () => {
        setShowConfirmation(false);

        await axios.delete(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}`);

        onDelete();
    }

    const risco = row && row.risco !== undefined ? getRiscoEscala(row.risco) : null;
    const subtitle = [data.assoc && data.assoc.nome, data.microrregiao && data.microrregiao.nome].filter(Boolean).join(' · ');

    return (
        <Drawer>
            <DrawerBackdrop onClick={onClose} />
            <DrawerPanel role="dialog" aria-modal="true" aria-label={gid ? 'Perfil do fornecedor' : 'Novo fornecedor'}>
                <DrawerHeader>
                    <h5>{gid ? 'Perfil do fornecedor' : 'Novo fornecedor'}</h5>
                    <IconButton onClick={onClose} aria-label="Fechar"><FontAwesomeIcon icon={faTimes} /></IconButton>
                </DrawerHeader>

                <DrawerBody>
                    {gid && <>
                        <Profile>
                            <Avatar className={currentStatus === 'ativo' ? 'active' : ''}>{getInitials(data.nome)}</Avatar>
                            <div className="identity">
                                <strong>{data.nome || 'Carregando...'}</strong>
                                <small>{subtitle || '-'}</small>
                            </div>
                        </Profile>

                        <InfoList>
                            <dt>CPF</dt>
                            <dd>{data.cpf || '-'}</dd>
                            <dt>Status</dt>
                            <dd>{currentStatus ? <StatusDot className={currentStatus === 'ativo' ? 'success' : 'muted'}>{currentStatus === 'ativo' ? 'Ativo' : 'Inativo'}</StatusDot> : '-'}</dd>
                            <dt>Risco</dt>
                            <dd>{risco ? <RiscoDot risco={risco} /> : '-'}</dd>
                            <dt>Município</dt>
                            <dd>{(row && row.municipio) || '-'}</dd>
                        </InfoList>

                        <StatusActions>
                            <Button variant="outline-secondary" size="sm" onClick={toggleStatus} disabled={!currentStatus || changingStatus}>
                                <FontAwesomeIcon icon={currentStatus === 'ativo' ? faToggleOff : faToggleOn} /> {currentStatus === 'ativo' ? 'Desativar fornecedor' : 'Ativar fornecedor'}
                            </Button>
                            <Button variant="outline-danger" size="sm" onClick={() => setShowConfirmation(true)}>
                                <FontAwesomeIcon icon={faTrashAlt} /> Remover
                            </Button>
                        </StatusActions>
                    </>}

                    {data && <DrawerTabs
                        id="producer-tabs"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                    >
                        <Tab eventKey="main" title="Dados do produtor">
                            <ManageMain gid={gid} data={data} onUpdate={handleMainUpdate} onClose={onClose} assocs={assocs} />
                        </Tab>

                        {gid && <Tab eventKey="family" title="Família">
                            <ManageFamily gid={gid} data={data} onUpdate={handleUpdate} />
                        </Tab>}

                        {gid && <Tab eventKey="production" title="Produção">
                            <ManageProduction gid={gid} data={data} onUpdate={handleUpdate} />
                        </Tab>}
                    </DrawerTabs>}
                </DrawerBody>
            </DrawerPanel>

            <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmação de Remoção</Modal.Title>
                </Modal.Header>
                <Modal.Body>Você confirma a exclusão deste produtor!?</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-dark" onClick={() => setShowConfirmation(false)}>
                        Cancelar
                    </Button>
                    <Button variant="dark" onClick={handleRemove}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Drawer>
    );
}
function ManageFamily({ gid, data, onUpdate }) {

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [removeID, setRemoveID] = useState(false);

    const [showMng, setShowMng] = useState(false);

    const [value, setValue] = useState(null);
    const [relationType, setRelationType] = useState(0);
    const [options, setOptions] = useState(null);

    useEffect(() => {
        async function getFamilyOptions() {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/family_options`);
            setOptions(data);
        }

        getFamilyOptions();
    }, [])

    const startMng = (id) => {

        setRelationType(0);
        setValue(null);

        setShowMng(true);
    }

    const startRemove = (gid) => {
        setRemoveID(gid);
        setShowConfirmation(true);
    }

    const handleRemove = async () => {
        setShowConfirmation(false);

        await axios.delete(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}/family/${removeID}`);

        onUpdate();
    }

    const handleCloseMng = () => {
        setShowMng(false);
        setRelationType(0)
        setValue(null);
    }

    const handleSave = async () => {

        try {
            await axios.post(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}/family`, {
                relationType,
                other_id: value.value,
            });

            onUpdate();
            handleCloseMng();
        } catch (err) { }
    }

    const promiseOptions = (inputValue, callback) => {
        axios
            .get(
                `${process.env.REACT_APP_SERVER}geo-service/producers/search/?filter=${inputValue}&type=family&gid=${gid}`,
            )
            .then(function ({ data }) {
                callback(data);
            });
    };

    const handleFornecedorSeachChange = (selectedOption) => {
        setValue(selectedOption);
    }

    return (
        <div>
            <SectionHeader>
                <span>Familiares cadastrados</span>
                <GhostButton type="button" onClick={() => startMng()}><FontAwesomeIcon icon={faPlus} /> Adicionar</GhostButton>
            </SectionHeader>
            <ListTable>
                        <thead>
                            <tr>
                                <th>Parente</th>
                                <th>Relação (o parente é)</th>
                                <th className="actions"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!data.family && <tr><td colSpan={colspan} style={{ textAlign: 'center' }}>Carregando...</td></tr>}
                            {data.family && data.producao.family === 0 && <tr><td colSpan={colspan} style={{ textAlign: 'center' }}>Nenhum item encontrado!</td></tr>}
                            {data.family && data.family.map((row) => {

                                return <tr key={row.id}>
                                    <td><div /* style={{ cursor: 'pointer' }} onClick={() => {window.location.href = `/produtores/gerenciar/${row['outro_id']}`}} */>{row['outro_nome']}</div></td>
                                    <td>{row['relacao_nome']}</td>

                                    <td className="actions">
                                        <RowMenuToggle type="button" onClick={() => startRemove(row['id'])} aria-label="Remover"><FontAwesomeIcon icon={faTrashAlt} /></RowMenuToggle>
                                    </td>
                                </tr>
                            })}
                        </tbody>
            </ListTable>

            <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmação de Remoção</Modal.Title>
                </Modal.Header>
                <Modal.Body>Você confirma a exclusão deste dado!?</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-dark" onClick={() => setShowConfirmation(false)}>
                        Cancelar
                    </Button>
                    <Button variant="dark" onClick={handleRemove}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showMng} onHide={handleCloseMng}>
                <Modal.Header closeButton>
                    <Modal.Title>Gerenciar familiares</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Parente*</Form.Label>
                                    <div>
                                        <AsyncSelect
                                            loadOptions={promiseOptions}
                                            isClearable
                                            noOptionsMessage={() => 'Nenhum produtor encontrado!'}
                                            loadingMessage={() => 'Buscando...'}
                                            placeholder={'Digite o nome do produtor...'}
                                            value={value}
                                            onChange={handleFornecedorSeachChange}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Relação (o parente é)*</Form.Label>
                                    {!!options && <Form.Control as="select" custom value={relationType} onChange={(e) => setRelationType(e.target.value)}>
                                        <option value={0}> -- Selecione uma relação familiar -- </option>
                                        {options.map(option => <option key={`${option.id}_${option.position}`} value={`${option.id}_${option.position}`}>{option.p_type}</option>)}
                                    </Form.Control>}
                                    {!options && <div>Carregando...</div>}
                                </Form.Group>
                            </Col>
                        </Row>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-dark" onClick={handleCloseMng}>
                        Cancelar
                    </Button>
                    <Button variant="dark" onClick={handleSave} disabled={!value || relationType === 0}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
function ManageProduction({ gid, data, onUpdate }) {

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [removeGID, setRemoveGID] = useState(false);

    const [showMng, setShowMng] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [ano, setAno] = useState(lastYear);
    const [value, setValue] = useState(0);
    const [yearOptions, setYearOptions] = useState([]);

    const startMng = (id) => {

        let yControl;
        if (id) {
            setEditingId(id);

            const current = data.producao.filter(({ id: prodId }) => prodId === id)[0];

            setValue(current.vol_kg);

            yControl = getYearControl(current.ano);

        } else {
            yControl = getYearControl();
        }

        setYearOptions(yControl.options);
        setAno(yControl.selected);

        setShowMng(true);
    }

    const startRemove = (gid) => {
        setRemoveGID(gid);
        setShowConfirmation(true);
    }

    const handleRemove = async () => {
        setShowConfirmation(false);

        await axios.delete(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}/production/${removeGID}`);

        onUpdate();
    }

    const handleCloseMng = () => {
        setShowMng(false);
        setEditingId(null);
        setAno(lastYear);
        setValue(0);
    }

    const handleSave = async () => {
        try {
            const floatValue = parseFloat(value);

            if (editingId) {
                await axios.put(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}/production/${editingId}`, {
                    ano,
                    value: floatValue,
                });
            } else {
                await axios.post(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid}/production`, {
                    ano,
                    value: floatValue,
                });
            }

            onUpdate();
            handleCloseMng();
        } catch (err) { }
    }

    const getYearControl = (current) => {
        // lastYear até 2009, sem valores já adicionados, com valor atual (se houver)

        const options = [];

        const jaAdicionados = data.producao ? data.producao.map(prod => prod.ano) : [];
        for (let ano = 2009; ano <= lastYear; ano++) if (!jaAdicionados.includes(ano) || ano === current) options.push(ano);
        options.sort().reverse();

        let selected = options[0];
        if (current) selected = current;

        return {
            options: options,
            selected,
        };
    }

    return (
        <div>
            <SectionHeader>
                <span>Produção por ano</span>
                <GhostButton type="button" onClick={() => startMng()}><FontAwesomeIcon icon={faPlus} /> Adicionar</GhostButton>
            </SectionHeader>
            <ListTable>
                        <thead>
                            <tr>
                                <th>Ano</th>
                                <th className="number">Produção (kg)</th>
                                <th className="actions"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!data.producao && <tr><td colSpan={colspan} style={{ textAlign: 'center' }}>Carregando...</td></tr>}
                            {data.producao && data.producao.length === 0 && <tr><td colSpan={colspan} style={{ textAlign: 'center' }}>Nenhum item encontrado!</td></tr>}
                            {data.producao && data.producao.sort(perYear).map((row, idx) => {

                                return <tr key={idx}>
                                    <td>{row['ano']}</td>
                                    <td className="number">{numeral(parseFloat(row['vol_kg'])).format('0,0.00')}</td>

                                    <td className="actions nowrap">
                                        <RowMenuToggle type="button" onClick={() => startMng(row['id'])} aria-label="Editar"><FontAwesomeIcon icon={faPencilAlt} /></RowMenuToggle>
                                        <RowMenuToggle type="button" onClick={() => startRemove(row['id'])} aria-label="Remover"><FontAwesomeIcon icon={faTrashAlt} /></RowMenuToggle>
                                    </td>
                                </tr>
                            })}
                        </tbody>
            </ListTable>

            <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmação de Remoção</Modal.Title>
                </Modal.Header>
                <Modal.Body>Você confirma a exclusão deste dado!?</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-dark" onClick={() => setShowConfirmation(false)}>
                        Cancelar
                    </Button>
                    <Button variant="dark" onClick={handleRemove}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showMng} onHide={handleCloseMng}>
                <Modal.Header closeButton>
                    <Modal.Title>Gerenciar valor de produção</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <Row>
                            <Col>
                                {yearOptions && <Form.Group>
                                    <Form.Label>Ano*</Form.Label>
                                    <Form.Control as="select" custom value={ano} onChange={(e) => setAno(e.target.value)}>
                                        {yearOptions.map(year => <option key={year} value={year}>{year}</option>)}
                                    </Form.Control>
                                </Form.Group>}
                                {!yearOptions && <div>Todos os anos foram preenchidos!</div>}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Valor (kg)*</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="value" value={value} onChange={(e) => setValue(e.target.value)} />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-dark" onClick={handleCloseMng}>
                        Cancelar
                    </Button>
                    <Button variant="dark" onClick={handleSave}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
function ManageMain({ gid, data, assocs, onUpdate, onClose }) {
    const fileInput = useRef();

    const [micros, setMicros] = useState([]);
    const [saving, setSaving] = useState(false);
    const [conflict, setConflict] = useState(false);

    const [distance, _distance] = useState(0);

    const [currentAssoc, setCurrentAssoc] = useState(null);

    const [cpfDeduped, setcpfDeduped] = useState('validated');

    useEffect(() => {
        async function fetchMicros() {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/micros/per_assoc/${currentAssoc}`);
            setMicros(data);
        }

        if (currentAssoc) fetchMicros()
        else setMicros([]);

    }, [currentAssoc]);

    useEffect(() => {
        if (data && data.assoc) setCurrentAssoc(data.assoc.id);
    }, [data]);

    const updateMicros = (e) => {
        setCurrentAssoc(e.target.value);
    }

    const validate = async values => {
        const errors = {};

        if (!values.nome) {
            errors.nome = 'O NOME deve ser preenchido';
        }
        if (!values.cpf || values.cpf.length < 14) {
            errors.cpf = 'O CPF deve ser preenchido';
        }
        if (parseInt(values.assoc) === -1) {
            errors.assoc = 'A ASSOCIAÇÃO / COOPERATIVA deve ser preenchida';
        }
        if (parseInt(values.microrregiao) === -1) {
            errors.microrregiao = 'A MICRORREGIÃO deve ser preenchida';
        }
        /* if (!values.colocacao) {
            errors.colocacao = 'A COLOCAÇÃO deve ser preenchida';
        }
        if (!values.seringal) {
            errors.seringal = 'O SERINGAL deve ser preenchido';
        } */
        if (!values.lat) {
            errors.lat = 'A LATITUDE deve ser preenchida';
        }
        if (!values.long) {
            errors.long = 'A LONGITUDE deve ser preenchida';
        }
        if (values.ai_type === 'radius' && !values.ai_radius) {
            errors.ai_radius = 'A ÁREA DE INFLUÊNCIA deve ser preenchida';
        }

        return errors;
    };

    const save = async (saveData) => {
        const formData = new FormData();
        for (let [key, value] of Object.entries(saveData)) formData.append(key, value);

        setSaving(true);

        const { data } = await axios.post(`${process.env.REACT_APP_SERVER}geo-service/manage/producers/${gid ? gid : ''}`, formData);
        // if (!!data.error) {
        //     if (data.code === 'coords_shape_conflict') setConflict(true);
        // } else {
            const { gid: savedId, info } = data;
            onUpdate(!gid ? savedId : null);
        // }

        if(info.intersects) _distance(0);
        else _distance(info.distance);

        setSaving(false);

    }

    const checkCPFDedup = async (e) => {
        if (e.target.value.length < 14) {
            setcpfDeduped('validated');
            return;
        }

        setcpfDeduped('validating');
        const { data: cpfCheck } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/checkcpf/?cpf=${e.target.value}&gid=${gid ? gid : ''}`, data);

        setcpfDeduped(cpfCheck.error ? 'error' : 'validated');
    }

    return (
        <div>
            <Formik
                validate={validate}
                onSubmit={save}
                enableReinitialize={true}
                initialValues={{
                    nome: data.nome ? data.nome : '',
                    cpf: data.cpf ? data.cpf : '',
                    colocacao: data.colocacao ? data.colocacao : '',
                    seringal: data.seringal ? data.seringal : '',
                    assoc: data.assoc ? data.assoc.id : -1,
                    microrregiao: data.microrregiao ? data.microrregiao.id : -1,
                    lat: data.lat ? data.lat : '',
                    long: data.long ? data.long : '',
                    ai_type: data.ai_type ? data.ai_type : 'radius',
                    ai_radius: data.ai_radius !== undefined ? data.ai_radius : '',
                    ai_shapefile: null,
                    ai_shapefile_name: data.ai_shapefile_name ? data.ai_shapefile_name : '',
                    ai_srid: 'EPSG:4326',
                    ai_coords: data.ai_coords ? data.ai_coords : '',
                }}
            >
                {({
                    setFieldValue,
                    handleSubmit,
                    handleChange,
                    values,
                    touched,
                    errors,
                }) => (
                    <Form noValidate onSubmit={(e) => { handleSubmit(e); }} encType='multipart/form-data'>
                        <Row>
                            <Col sm={8}>
                                <Form.Group>
                                    <Form.Label>Nome*</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="nome" placeholder="Digite o NOME do produtor" value={values.nome} onChange={handleChange} isValid={touched.nome && !errors.nome} isInvalid={!!errors.nome} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.nome}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>

                            <Col sm={4}>
                                <Form.Group>
                                    <Form.Label>CPF*</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="cpf" placeholder="Digite o CPF do produtor" value={values.cpf} onChange={(e) => { e.target.value = maskCPF(e.target.value); handleChange(e); checkCPFDedup(e); }} isValid={touched.cpf && !errors.cpf && cpfDeduped !== 'error'} isInvalid={cpfDeduped === 'error' || !!errors.cpf} />
                                        <Form.Control.Feedback type="invalid">
                                            {cpfDeduped === 'error' ? 'Este CPF já está cadastrado na base de dados!' : errors.cpf}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={6}>

                                <Form.Group>
                                    <Form.Label>Associação / Cooperativa*</Form.Label>
                                    <InputGroup>

                                        <Form.Control as="select" name="assoc" value={values.assoc} onChange={(e) => { handleChange(e); updateMicros(e); }} isValid={touched.assoc && !errors.assoc} isInvalid={!!errors.assoc} custom>
                                            <option value={-1}> -- Selecione uma Associação / Cooperativa -- </option>
                                            {assocs && assocs.map(({ id, nome }) => <option key={id} value={id}>{nome}</option>)}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.assoc}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col sm={6}>

                                <Form.Group>
                                    <Form.Label>Microrregião*</Form.Label>
                                    <InputGroup>

                                        <Form.Control as="select" name="microrregiao" value={values.microrregiao} onChange={handleChange} isValid={touched.microrregiao && !errors.microrregiao} isInvalid={!!errors.microrregiao} custom>
                                            <option value={-1}> -- Selecione uma Microrregião -- </option>
                                            {micros && micros.map(({ id, nome }) => <option key={id} value={id}>{nome}</option>)}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.microrregiao}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Colocação</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="colocacao" placeholder="Digite o COLOCAÇÃO do produtor" value={values.colocacao} onChange={handleChange} isValid={touched.colocacao && !errors.colocacao} isInvalid={!!errors.colocacao} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.colocacao}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>

                            <Col>
                                <Form.Group>
                                    <Form.Label>Seringal</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="seringal" placeholder="Digite o SERINGAL do produtor" value={values.seringal} onChange={handleChange} isValid={touched.seringal && !errors.seringal} isInvalid={!!errors.seringal} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.seringal}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Latitude* (Y)</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="lat" type="number" placeholder="Digite a LATITUDE do produtor" value={values.lat} onChange={(e) => { handleChange(e); setConflict(false); _distance(0); }} isValid={touched.lat && !errors.lat} isInvalid={!!errors.lat} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.lat}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>

                            <Col>
                                <Form.Group>
                                    <Form.Label>Longitude* (X)</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="long" type="number" placeholder="Digite a LONGITUDE do produtor" value={values.long} onChange={(e) => { handleChange(e); setConflict(false); _distance(0); }} isValid={touched.long && !errors.long} isInvalid={!!errors.long} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.long}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Tipo de Área de influência*</Form.Label>
                                    <InputGroup>
                                        <Form.Control as="select" name="ai_type" value={values.ai_type} onChange={e => {

                                            setFieldValue("ai_radius", '');
                                            setFieldValue("ai_shapefile", null);
                                            setFieldValue("ai_coords", '');
                                            setConflict(false);
                                            _distance(0);

                                            if (e.target.value === 'shapefile') fileInput.current.click();
                                            else {
                                                setFieldValue("ai_type", e.target.value);
                                            }
                                        }} /* isValid={touched.assoc && !errors.assoc} isInvalid={!!errors.assoc} */ custom>
                                            <option value="none"> -- Selecione o tipo de Área de influência -- </option>
                                            <option value="radius">Raio</option>
                                            <option value="shapefile">Shapefile</option>
                                            <option value="coords">Coordenadas</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.assoc}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            {values.ai_type === 'radius' && <Col>
                                <Form.Group>
                                    <Form.Label>Raio (metros)*</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="ai_radius" type="number" placeholder="Digite o ÁREA DE INFLUÊNCIA do produtor" value={values.ai_radius} onChange={handleChange} isValid={touched.ai_radius && !errors.ai_radius} isInvalid={!!errors.ai_radius} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.ai_radius}
                                        </Form.Control.Feedback>
                                    </InputGroup>
                                </Form.Group>
                            </Col>}
                            {values.ai_type === 'shapefile' && <Col>
                                <Form.Group>
                                    <Form.Label>Arquivo shapefile (.zip ou .shp)*</Form.Label>
                                    <div>
                                        {(values.ai_shapefile || values.ai_shapefile_name) && <SpacedButton title="alterar" variant="outline-dark" onClick={() => fileInput.current.click()}>
                                            {values.ai_shapefile?.name || values.ai_shapefile_name || ''}
                                        </SpacedButton>}
                                    </div>
                                    <Form.Control as="select" name="ai_srid" value={values.ai_srid} onChange={handleChange} custom>
                                        <option value="EPSG:4326">EPSG:4326 - WGS84 longitude/latitude</option>
                                        <option value="EPSG:31978">EPSG:31978 - SIRGAS 2000 / UTM 18S</option>
                                        <option value="EPSG:31979">EPSG:31979 - SIRGAS 2000 / UTM 19S</option>
                                        <option value="EPSG:31980">EPSG:31980 - SIRGAS 2000 / UTM 20S</option>
                                        <option value="EPSG:31981">EPSG:31981 - SIRGAS 2000 / UTM 21S</option>
                                        <option value="EPSG:31982">EPSG:31982 - SIRGAS 2000 / UTM 22S</option>
                                        <option value="EPSG:31983">EPSG:31983 - SIRGAS 2000 / UTM 23S</option>
                                        <option value="EPSG:31984">EPSG:31984 - SIRGAS 2000 / UTM 24S</option>
                                        <option value="EPSG:31985">EPSG:31985 - SIRGAS 2000 / UTM 25S</option>
                                    </Form.Control>
                                    {/* {conflict && <div className='invalid-feedback' style={{ display: 'block' }}>
                                        Há conflito entre as coordenadas e o shape inserido!
                                    </div>} */}
                                    {distance !== 0 && <div className='invalid-feedback' style={{ display: 'block' }}>
                                        As coordenadas deste produtor não estão inseridas na área de influência especificada ({numeral(distance/1000).format('0,0')} km)
                                    </div>}
                                </Form.Group>
                            </Col>}
                            {values.ai_type === 'coords' && <Col>
                                <Form.Group>
                                    <Form.Label>Coordenadas (LNG LAT em cada linha)*</Form.Label>
                                    <InputGroup>
                                        <Form.Control name="ai_coords" as="textarea" rows={4} placeholder="-68.64035595 -10.37968005" value={values.ai_coords} onChange={(e) => {
                                            const value = e.target.value.replace(/[^\d.\s\r\n-]/g, '')
                                            if(value === e.target.value) handleChange(e);
                                        }} isValid={touched.ai_coords && !errors.ai_coords} isInvalid={!!errors.ai_coords} />

                                        {conflict && <div className='invalid-feedback' style={{ display: 'block' }}>
                                            Há conflito entre as coordenadas da propriedade e da área de abrangência!
                                        </div>}
                                    </InputGroup>
                                </Form.Group>
                            </Col>}
                        </Row>
                        <FormActions>
                            <Button variant="outline-secondary" onClick={onClose}>
                                Cancelar
                            </Button>
                            <PrimaryButton type="submit" disabled={saving || cpfDeduped !== 'validated'}>
                                {saving ? 'Gravando...' : (gid ? 'Salvar alterações' : 'Cadastrar fornecedor')}
                            </PrimaryButton>
                        </FormActions>

                        <input
                            type="file"
                            accept=".zip,.shp"
                            ref={fileInput}
                            hidden
                            onChange={e => {
                                if (e.target.files.length) {
                                    setFieldValue("ai_type", 'shapefile');
                                    setFieldValue("ai_radius", '');
                                    setFieldValue("ai_shapefile", e.target.files[0]);
                                    setConflict(false);
                                }
                            }}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
}

let timer = null;
function List({ currentPage, assocs, producers, maxYear, filters, handleFilter, handleExport, paginatorData, handleEdit, handlePageChange, costPerKilo }) {
    const editing = useRouteMatch('/produtores/gerenciar/:id?');
    const selectedId = editing ? editing.params.id : null;

    const [name, _name] = useState('');
    const [assoc, _assoc] = useState(0);
    const [cpf, _cpf] = useState('');
    const [status, _status] = useState(0);

    useEffect(() => {
        _name(filters.name || '');
        _assoc(filters.assoc || 0);
        _cpf(filters.cpf || '');
        _status(filters.status || 0);
    }, [filters])

    const [hiddenColumns, setHiddenColumns] = useState(loadHiddenColumns);

    const toggleColumn = (key) => {
        const next = hiddenColumns.includes(key)
            ? hiddenColumns.filter((hidden) => hidden !== key)
            : [...hiddenColumns, key];

        saveHiddenColumns(next);
        setHiddenColumns(next);
    }

    const handleKey = (filter) => (e) => {
        if (timer) clearTimeout(timer);

        const value = e.target.value;
        if (e.key === "Enter") handleFilter(filter, value || false);
        else timer = setTimeout(() => handleFilter(filter, value || false), 1000); // debounce
    }

    const clearFilter = (filter) => {
        if (timer) clearTimeout(timer);
        handleFilter(filter, false);
    }

    const columns = [
        { key: 'nome', label: 'Nome', fixed: true, render: (row) => <span className="name">{row.nome}</span> },
        { key: 'cpf', label: 'CPF', render: (row) => row.cpf ? <Chip>{row.cpf}</Chip> : '-' },
        { key: 'status', label: 'Status', render: (row) => <StatusDot className={row.status === 'ativo' ? 'success' : 'muted'}>{row.status === 'ativo' ? 'Ativo' : 'Inativo'}</StatusDot> },
        { key: 'risco', label: 'Risco', render: (row) => <RiscoDot risco={getRiscoEscala(row.risco)} /> },
        { key: 'seringal', label: 'Seringal', render: (row) => row.seringal || '-' },
        { key: 'colocacao', label: 'Colocação', render: (row) => row.colocacao || '-' },
        { key: 'associacao', label: 'Associação / Cooperativa', render: (row) => row.assoc ? row.assoc.nome : '-' },
        { key: 'microrregiao', label: 'Microrregião', render: (row) => row.microrregiao ? row.microrregiao.nome : '-' },
        { key: 'municipio', label: 'Município', render: (row) => row.municipio || '-' },
        { key: 'ap', label: 'Área de Proteção', render: (row) => row.ap ? row.ap.nome : <span className="muted">Fora de área de proteção</span> },
        { key: 'production', label: `Prod. ${maxYear} (kg)`, number: true, render: (row) => numeral(getProduction(row)).format('0,0.00') },
        { key: 'production_value', label: `Prod. ${maxYear} (R$)`, number: true, render: (row) => `R$ ${numeral(getProduction(row) * (costPerKilo || 0)).format('0,0.00')}` },
    ];

    const visibleColumns = columns.filter((column) => column.fixed || !hiddenColumns.includes(column.key));
    const totalColumns = visibleColumns.length;

    const pages = paginatorData ? paginatorData.pages : 0;

    return (<Container>
        <Header>
            <div>
                <h4>Gestão de Fornecedores</h4>
                <small>Produtores cadastrados, com risco e produção de {maxYear}</small>
            </div>
            <HeaderActions>
                <Button variant="outline-secondary" onClick={handleExport}>
                    <FontAwesomeIcon icon={faDownload} /> Exportar Excel
                </Button>
                <PrimaryButton onClick={() => handleEdit()}>
                    <FontAwesomeIcon icon={faPlus} /> Novo fornecedor
                </PrimaryButton>
            </HeaderActions>
        </Header>

        <Panel>
            <Toolbar>
                <SearchBox>
                    <FontAwesomeIcon icon={faSearch} />
                    <input placeholder="Buscar fornecedor pelo nome..." value={name} onChange={(e) => _name(e.target.value)} onKeyUp={handleKey('name')} />
                    {!!filters.name && <ClearButton onClick={() => clearFilter('name')} title="Limpar"><FontAwesomeIcon icon={faTimes} /></ClearButton>}
                </SearchBox>

                <ToolbarFilters>
                    <SearchBox className="compact">
                        <input placeholder="CPF" value={cpf} onChange={(e) => _cpf(maskCPF(e.target.value))} onKeyUp={handleKey('cpf')} />
                        {!!filters.cpf && <ClearButton onClick={() => clearFilter('cpf')} title="Limpar"><FontAwesomeIcon icon={faTimes} /></ClearButton>}
                    </SearchBox>

                    <FilterSelect value={assoc} onChange={(e) => { _assoc(e.target.value); handleFilter('assoc', e.target.value === '0' ? false : e.target.value) }}>
                        <option value="0">Todas as associações</option>
                        {assocs && assocs.map(({ id, nome }) => <option key={id} value={id}>{nome}</option>)}
                    </FilterSelect>

                    <FilterSelect value={status} onChange={(e) => { _status(e.target.value); handleFilter('status', e.target.value === '0' ? false : e.target.value) }}>
                        <option value="0">Todos os status</option>
                        <option value="ativo">Ativos</option>
                        <option value="inativo">Inativos</option>
                    </FilterSelect>

                    <Dropdown alignRight>
                        <Dropdown.Toggle as={GhostButton}>
                            <FontAwesomeIcon icon={faColumns} /> Colunas
                        </Dropdown.Toggle>
                        <ColumnsMenu>
                            {columns.map((column) => <Form.Check
                                key={column.key}
                                id={`producer-column-${column.key}`}
                                type="checkbox"
                                label={column.label}
                                disabled={column.fixed}
                                checked={column.fixed || !hiddenColumns.includes(column.key)}
                                onChange={() => toggleColumn(column.key)}
                                className={column.fixed || !hiddenColumns.includes(column.key) ? 'checked' : ''}
                            />)}
                        </ColumnsMenu>
                    </Dropdown>
                </ToolbarFilters>
            </Toolbar>

            <TableScroll>
                <ListTable>
                    <thead>
                        <tr>
                            {visibleColumns.map((column) => <th key={column.key} className={column.number ? 'number' : ''}>{column.label}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {!producers && <tr><CenteredTD colSpan={totalColumns}>Carregando...</CenteredTD></tr>}
                        {producers && producers.length === 0 && <tr><CenteredTD colSpan={totalColumns}>Nenhum fornecedor encontrado!</CenteredTD></tr>}
                        {producers && producers.map((row) => <StyledTR
                            key={row.gid}
                            className={`clickable ${row.status === 'inativo' ? 'inactive' : ''} ${String(row.gid) === selectedId ? 'selected' : ''}`}
                            tabIndex={0}
                            onClick={() => handleEdit(row.gid)}
                            onKeyDown={(e) => { if (e.key === 'Enter') handleEdit(row.gid); }}
                        >
                            {visibleColumns.map((column) => <td key={column.key} className={column.number ? 'number' : ''}>{column.render(row)}</td>)}
                        </StyledTR>)}
                    </tbody>
                </ListTable>
            </TableScroll>

            <Footer>
                <span>{pages ? `Página ${currentPage} de ${pages}` : ''}</span>
                <div>
                    <PageButton disabled={!paginatorData || !paginatorData.hasPrevious} onClick={() => handlePageChange(currentPage - 1)} aria-label="Página anterior">
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </PageButton>
                    <PageButton disabled={!paginatorData || !paginatorData.hasNext} onClick={() => handlePageChange(currentPage + 1)} aria-label="Próxima página">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </PageButton>
                </div>
            </Footer>
        </Panel>
    </Container>);
}

function maskCPF(cpf) {
    const cleanCPF = cpf.replace(/[^0-9]/g, ''); //cpf.replace(/\./g, '').replace(/-/, '').replace(/ /, '').replace(/[a-zA-Z]/, '');
    let maskedCPF = '';

    for (let idx = 0; idx < cleanCPF.length; idx++) {
        if (idx === 3 || idx === 6) maskedCPF += '.';
        if (idx === 9) maskedCPF += '-';
        maskedCPF += cleanCPF[idx];
    }

    return maskedCPF;
}

function perYear(a, b) {
    if (a.ano > b.ano) return -1;
}

const HIDDEN_COLUMNS_KEY = 'producersHiddenColumns';

function loadHiddenColumns() {
    try {
        const stored = JSON.parse(localStorage.getItem(HIDDEN_COLUMNS_KEY));
        return Array.isArray(stored) ? stored : [];
    } catch (e) {
        return [];
    }
}

function saveHiddenColumns(hiddenColumns) {
    try {
        localStorage.setItem(HIDDEN_COLUMNS_KEY, JSON.stringify(hiddenColumns));
    } catch (e) {
        console.log(e);
    }
}

function getProduction(row) {
    return row.producao ? parseFloat(row.producao.vol_kg) || 0 : 0;
}

function getInitials(nome) {
    if (!nome) return '';

    const parts = nome.trim().split(/\s+/);
    const first = parts[0][0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';

    return (first + last).toUpperCase();
}

function RiscoDot({ risco }) {
    return <StatusDot className={risco === 'ALTO' ? 'danger' : 'success'}>{risco === 'ALTO' ? 'Alto' : 'Baixo'}</StatusDot>;
}

/* Styles */

const SpacedButton = styled(Button)`
    margin-right: 10px;
`;

const ColumnsMenu = styled(Dropdown.Menu)`
    padding: 8px 4px;
    min-width: 240px;
    border: none;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(17, 24, 39, .12);

    .form-check {
        padding: 6px 12px 6px 36px;
        border-radius: 6px;
        font-size: 14px;
    }

    .form-check:hover {
        background-color: var(--vft-subtle);
    }

    .form-check-input {
        margin-left: -24px;
        margin-top: 4px;
        accent-color: var(--vft-ink);
    }

    .form-check.checked:not(:first-child) label {
        color: var(--vft-ink);
        font-weight: 600;
    }
`;

const Profile = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 8px 0 16px;

    .identity {
        display: flex;
        flex-direction: column;
        min-width: 0;
    }

    .identity strong {
        font-size: 16px;
        font-weight: 600;
    }

    .identity small {
        color: var(--vft-muted);
    }
`;

const Avatar = styled.div`
    position: relative;
    flex: 0 0 auto;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--vft-hover);
    color: var(--vft-ink);
    font-weight: 600;

    &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 1px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 2px solid #fff;
        background-color: var(--vft-border-strong);
    }

    &.active::after {
        background-color: var(--vft-success);
    }
`;

const InfoList = styled.dl`
    display: grid;
    grid-template-columns: 140px 1fr;
    row-gap: 10px;
    margin: 0;
    padding: 4px 0 16px;

    dt {
        font-weight: normal;
        color: var(--vft-muted);
    }

    dd {
        margin: 0;
    }
`;

export default ManageProducers;
